/**
 * AUS EINEM VORGANG ZWEI MACHEN (PO 28.09.2026) — die Regeln ohne React.
 *
 * Geteilt wird in To-do-Einheiten: Die gewählten To-dos bilden samt ihrem
 * Schriftwechsel einen NEUEN Vorgang, die übrigen bleiben. Damit gilt die
 * Invariante „mit To-dos gehört alles einem To-do" auf beiden Seiten von
 * selbst. Der Server prüft dasselbe noch einmal (`TodoService.teileVorgang`).
 */

/** Warum der Knopf nicht geht — oder `null`. Als Satz, nicht als `boolean`. */
export function teilenFehler(args: { gewaehlt: number; gesamt: number; titel: string }): string | null {
    if (args.gewaehlt === 0) return "Bitte mindestens ein To-do auswählen, das in den neuen Vorgang soll.";
    if (args.gewaehlt >= args.gesamt) {
        return "Mindestens ein To-do muss hier bleiben — sonst genügt es, den Vorgang umzubenennen.";
    }
    if (!args.titel.trim()) return "Bitte einen Betreff für den neuen Vorgang angeben.";
    return null;
}

/**
 * Der Betreff, der im Feld vorgeschlagen wird: Bei genau EINEM gewählten
 * To-do dessen Betreff — der neue Vorgang ist dann genau diese Arbeit. Bei
 * mehreren gibt es keinen natürlichen Namen; dann bleibt das Feld leer und
 * fragt danach.
 */
export function teilenVorschlag(gewaehlteTitel: string[]): string {
    return gewaehlteTitel.length === 1 ? (gewaehlteTitel[0] ?? "").trim() : "";
}

/** Die Folge im Klartext, VOR der Handlung. */
export function teilenFolgeText(args: { gewaehlt: number; gesamt: number; titel: string; alterTitel: string }): string {
    const neu = args.titel.trim() || "(ohne Betreff)";
    const alt = args.alterTitel.trim() || "(ohne Betreff)";
    const rest = args.gesamt - args.gewaehlt;
    const wandern = args.gewaehlt === 1 ? "1 To-do wandert" : `${args.gewaehlt} To-dos wandern`;
    const bleiben = rest === 1 ? "1 bleibt" : `${rest} bleiben`;
    return `${wandern} mit Notizen, Mails, Anrufen, Terminen und Dokumenten in den neuen Vorgang „${neu}“; ${bleiben} in „${alt}“.`;
}
